import Card from "./hero/cards";
import Title from "./hero/title";

const Hero = () => {
  return (
    <div className="flex flex-col">
      <Title />
      <Card />
    </div>
  );
};

export default Hero;
